import React from 'react'
import { useActiveWeb3React } from '../../../../../hooks'
import { YTS } from '../../../../../constants'

import { ReactComponent as VerifiedIcon } from '../../../../../assets/svg/verified.svg'

import {
  CardNavLink,
  NFTCardImage,
  NFTCardMeta,
  NFTCardPrice,
  NFTCardTitle,
  NFTCardView,
  CardImageNavLink,
  NFTCardImageOverlay
} from '../../../components/NFTCard/syled'
import { IBaseCard } from '../../../components/NFTCard/INFTCard'
import { useGetSaleTokenItem, useGetNFTPrice } from '../../../../../hooks/useNFTMarketPlace'
import NFTCardButtons from '../../Default/components/NFTCardButtons/NFTCardButtons'
import NFTPriceSymbol from '../../../components/NFTPriceSymbol'
import { ReactComponent as ForkIcon } from '../../../../../assets/svg/git-fork.svg'
import { ReactComponent as AlertIcon } from '../../../../../assets/svg/alert.svg'
import { useGetCreators } from '../../../../../hooks/useYetiSwapNFTCollection'
import NFTUserInfoCompact from '../../../components/NFTUserInfoCompact'
import { CardMeta, CardContainer, CardImage, CardTitle, CardCollection, CardCreator, CreatorImage, CreatorInfo, CreatorLabel, CreatorName, CardPrice, CardButtons, CardButton } from '../../../newComponents/NFTCard/styled'

export default function BaseCard(props: IBaseCard) {
  const {
    token,
    tokenId,
    collection,
    detailUrl,
    setSale,
    transferNFT,
    approve,
    buyNow,
    isSale,
    isWallet,
    removeSale,
    approveState,
    //account,
    saleToken,
    owner,
    tokenName,
    children,
    priceInfo,
    customStyleCardImage,
    stakeToggle,
    stakeState,
    isStake
  } = props
  const { chainId } = useActiveWeb3React()
  const tokenCreator = useGetCreators(tokenId);


  const yts = chainId !== undefined ? YTS[chainId] : undefined
  const NFTTokenPrice: string = useGetNFTPrice(token?.price, yts, true)
  const saleTokenItem = useGetSaleTokenItem(saleToken)
  let fiatPrice: number | null = null

  if (priceInfo && token && token.price) {
    if (saleTokenItem.symbol === 'YTS') {
      fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.usdPrice
    } else {
      fiatPrice = parseFloat(NFTTokenPrice) * priceInfo.avaxUsdPrice
    }
  }

  const tokenLink = `${detailUrl}/${collection.tokenAddress}/${tokenId}`

  return (
    <CardContainer>
      <CardImageNavLink className="link" to={tokenLink}>
        <CardImage style={customStyleCardImage}>
          {children}
        </CardImage>
      </CardImageNavLink>
      <CardTitle title={tokenName}>
        {tokenName}
      </CardTitle>
      {collection?.tokenAddress.toLowerCase() !== '0x0000000004bFeF9b1A67aA4E15943824996c9761'.toLowerCase() ? <CardCollection title='Verified Collection'>
        {collection.forkProject && (
          <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
        )}
        {collection.oldProject && (
          <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
        )}
        <VerifiedIcon width="1rem" />
        {collection.name}
      </CardCollection>
        :
        tokenCreator && <NFTUserInfoCompact accountAddress={tokenCreator} currentAccountAdress={null} label='Creator' />
      }
      <CardMeta>
        {token?.seller && <NFTUserInfoCompact accountAddress={token?.seller} currentAccountAdress={null} label='Seller' />}
        {isSale ? (
          <CardPrice>
            <span>Price</span>
            <div>
              {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
            </div>
            {fiatPrice && <div>{fiatPrice.toFixed(2)} USD</div>}
          </CardPrice>
        ) : (
          'Not For Sale'
        )}
      </CardMeta>
      <CardButtons>
        <NFTCardButtons
          tokenContractAddress={collection.tokenAddress}
          tokenId={tokenId}
          isWallet={isWallet}
          token={token}
          setSale={setSale}
          approve={approve}
          buyNow={buyNow}
          isSale={isSale}
          tokenName={tokenName}
          removeSale={removeSale}
          transferNFT={transferNFT}
          approveState={approveState}
          //account={account}
          saleToken={saleToken}
          owner={owner}
          priceInfo={priceInfo}
          stakeToggle={stakeToggle}
          stakeState={stakeState}
          isStake={isStake}
        />
      </CardButtons>
    </CardContainer>
  )

  return (
    <NFTCardView className="nft-card-view2">
      <NFTCardImage className="nft-card-image" style={customStyleCardImage}>
        <CardImageNavLink className="link" to={tokenLink}>
          {children}
          <NFTCardImageOverlay className="image-overlay">Details</NFTCardImageOverlay>
        </CardImageNavLink>
      </NFTCardImage>
      <NFTCardMeta>
        <CardNavLink to={tokenLink}>
          {collection.tokenAddress !== '0x0000000004bFeF9b1A67aA4E15943824996c9761' ? (
            <div className="CollectionAddress" title={`${collection.name} Verified Collection`}>
              {collection.forkProject && (
                <ForkIcon width="0.9rem" height="0.9rem" className="form-icon" title="Forked Collection" />
              )}
              {collection.oldProject && (
                <AlertIcon width="0.9rem" height="0.9rem" className="form-icon" title="Old Project, You need to migrate new version" />
              )}
              <VerifiedIcon width="1rem" /> {collection.name}
            </div>
          ) : (
            tokenCreator ?
              <div className="CollectionAddress">
                Creator{" : "}<NFTUserInfoCompact accountAddress={tokenCreator} currentAccountAdress={null} />
              </div>
              :
              <div className="collectionPlaceHolder" />
          )}

          <NFTCardTitle title={tokenName}>{tokenName}</NFTCardTitle>
          {isSale ? (
            <NFTCardPrice>
              <div className="tokenPrice">
                {NFTTokenPrice} <NFTPriceSymbol symbol={saleTokenItem.symbol} image={saleTokenItem.image} />
              </div>
              {fiatPrice && <div className="fiat-price">(${fiatPrice?.toFixed(2)})</div>}
            </NFTCardPrice>
          ) : (
            'Not For Sale'
          )}
        </CardNavLink>
      </NFTCardMeta>
      <NFTCardButtons
        tokenContractAddress={collection.tokenAddress}
        tokenId={tokenId}
        isWallet={isWallet}
        token={token}
        setSale={setSale}
        approve={approve}
        buyNow={buyNow}
        isSale={isSale}
        tokenName={tokenName}
        removeSale={removeSale}
        transferNFT={transferNFT}
        approveState={approveState}
        //account={account}
        saleToken={saleToken}
        owner={owner}
        priceInfo={priceInfo}
        stakeToggle={stakeToggle}
        stakeState={stakeState}
        isStake={isStake}
      />
    </NFTCardView>
  )
}
